import { useTranslation } from 'react-i18next'
import { UISelect, UISelectItem } from 'src/components/ui/Select'
import Text from 'src/components/ui/Text'
import { useLoraCategories } from 'src/stores/model'
import { cx } from 'src/utils/cx'

/**
 * Ported from ModelInfoForm
 */
export function TrainLoraCategories(props: {
  value: string | null
  onChange: (value: string) => void
  className?: string
}) {
  const { value, onChange, className } = props
  const { t } = useTranslation(['market', 'common'])
  const loraCategories = useLoraCategories()

  return (
    <div
      className={cx(
        'flex flex-col gap-1',
        'p-2 -m-2 rounded-xl data-[highlighted]:bg-amber-100 dark:data-[highlighted]:bg-amber-500/15',
        className,
      )}
    >
      <span className="text-primary font-medium">
        <Text i18nKey="common:category.label" />
      </span>
      <UISelect
        buttonClassName="w-full h-[42px] pl-4"
        popoverClassName="w-[--trigger-width]"
        selectValueClassName="data-[placeholder]:text-sm"
        selectedKey={value ?? null}
        onSelectionChange={k => onChange(k as string)}
        placeholder={t('market:submit.model-form.category.placeholder')}
        aria-label={t('common:category.label')}
      >
        {loraCategories.map(it =>
          it.value ? (
            <UISelectItem
              key={it.value}
              id={it.value}
              labelClassName="text-sm"
              textValue={it.label}
            >
              <Text i18nKey={it.label} defaults={it.label} />
            </UISelectItem>
          ) : null,
        )}
      </UISelect>
    </div>
  )
}
